/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Guardrails_Title10Inputs */

const en_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safety & guardrails`)
};

const ar_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السلامة والحواجز الأمنية`)
};

const bn_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নিরাপত্তা ও গার্ডরেল`)
};

const de_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherheit und Leitplanken`)
};

const es_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguridad y barandillas`)
};

const fr_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sécurité et garde-corps`)
};

const pt_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segurança e grades de proteção`)
};

const zh_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全和护栏`)
};

const tr_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güvenlik ve korkuluklar`)
};

const ru_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасность и ограждения`)
};

const pl_svc_ai_agent_development_guardrails_title10 = /** @type {(inputs: Svc_Ai_Agent_Development_Guardrails_Title10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpieczeństwo i poręcze`)
};

/**
* | output |
* | --- |
* | "Safety & guardrails" |
*
* @param {Svc_Ai_Agent_Development_Guardrails_Title10Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_guardrails_title10 = /** @type {((inputs?: Svc_Ai_Agent_Development_Guardrails_Title10Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Guardrails_Title10Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "de") return de_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "es") return es_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_guardrails_title10(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_guardrails_title10(inputs)
	return en_svc_ai_agent_development_guardrails_title10(inputs)
});
export { svc_ai_agent_development_guardrails_title10 as "svc_ai-agent-development_GUARDRAILS_title" }